module.exports = __webpack_public_path__ + "img/new-equipment-2.f4d10313.jpg";